import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

export type VdIconName =
  | 'play' | 'buy' | 'subscribe' | 'lock' | 'clock' | 'like' | 'share' | 'playlist' | 'report'
  | 'tip' | 'donate' | 'polls' | 'back' | 'external' | 'send';

/*
 * Rounded line icons for the new video detail page (24 px grid, 1.8 stroke, currentColor),
 * drawn for this page so no icon package is added. `filled` fills shapes that support it (like, play).
 */
@Component({
  selector: 'app-vd-icon',
  templateUrl: './vd-icon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [':host{display:inline-flex;flex-shrink:0;line-height:0}svg{width:var(--vd-icon-size,18px);height:var(--vd-icon-size,18px)}'],
})
export class VdIconComponent {
  @Input() name: VdIconName = 'play';
  @Input() filled = false;
}
